import React from 'react';
import {useTranslation} from 'react-i18next';
import Checkbox from '../../../../../../component/checkbox/Checkbox';
import Btn from '../../../../../../component/button/btn/Btn';
import * as css from './FooterComponent.css';

interface FooterComponentProps {
    allActiveSelected: boolean;
    onSelectAllActive: (isSelected: boolean) => void;
    onClose: () => void;
    onSave: () => void;
    saveDisabled?: boolean;
    showSelectAll?: boolean;
}

function FooterComponent({allActiveSelected, onSelectAllActive, onClose, onSave, saveDisabled = false, showSelectAll = true}: FooterComponentProps) {
    const {t} = useTranslation('subscriptions');

    return (
        <css.footer>
            {showSelectAll && (
                <css.footerCheckbox data-cy="assign-events-select-all-checkbox">
                    <Checkbox
                        selected={allActiveSelected}
                        onClick={onSelectAllActive}
                        classes={'classicCheckbox'}
                        color="primary"
                    />
                    {t('selectAllActiveEvents')}
                </css.footerCheckbox>
            )}
            <css.footerButtons>
                <Btn
                    dataCy="assign-events-cancel"
                    className="white"
                    onClick={onClose}
                >
                    {t('cancel')}
                </Btn>
                <Btn
                    dataCy="assign-events-save"
                    className="primary"
                    onClick={onSave}
                    disabled={saveDisabled}
                >
                    {t('saveChanges')}
                </Btn>
            </css.footerButtons>
        </css.footer>
    );
}

export default FooterComponent;
